export default __webpack_public_path__ + "static/media/x-white.223d99e8.svg";